export const footer = {
  en: {
    copyright1: '2023/All rights reserved',
    copyright2: 'The site is designed for educational purposes',
    link: 'Original site',
  },
  ua: {
    copyright1: '2023/Всі права захищені',
    copyright2: 'Сайт розроблений в навчальних цілях',
    link: 'Оригінальний сайт',
  },
};
